import React from 'react';

import type { SpinnerProps } from './Spinner.types';

/**
 * Spinner - the button family's loading glyph.
 *
 * Sibling files had a byte-identical copy of this each. It stays private to
 * `Button/` and is not exported from the library barrel: a loading state that
 * is not inside a button should be a `Skeleton` reserving the shape it is
 * waiting for, not a spinner standing where content will be.
 *
 * `currentColor` throughout, so it inherits the button's ink for free; the
 * caller sizes it, because each button family has its own spinner scale.
 */
export function Spinner({ className = '' }: SpinnerProps): React.JSX.Element {
  return (
    <svg
      className={`animate-spin ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

export default Spinner;
